import { render, staticRenderFns } from "./zpqs.vue?vue&type=template&id=1555a3d3&scoped=true"
import script from "./zpqs.vue?vue&type=script&lang=js"
export * from "./zpqs.vue?vue&type=script&lang=js"
import style0 from "./zpqs.vue?vue&type=style&index=0&id=1555a3d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1555a3d3",
  null
  
)

export default component.exports